import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';

import LogoutIcon from '@mui/icons-material/Logout';
import { ROUTES } from '../../env/router';
import { Logout } from '../user/logout';
import { WAConteiner } from '../whatsapp/container';
import ContactMailIcon from '@mui/icons-material/ContactMail';

import QueryStatsIcon from '@mui/icons-material/QueryStats';
import GradingIcon from '@mui/icons-material/Grading';
import { Propostals } from '../propostals/propostals';
import { CashBook } from '../cachbook/cachbook';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { ConversationSearch } from '../whatsapp/talk';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { CLT } from '../clt/clt';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { AdmPage } from '../adm';
import { DashPage } from '../dashboard';
import { UserLeads } from '../userleads/leads';
import BugReportIcon from '@mui/icons-material/BugReport';
import { TestChat } from '../testchat/testchat';
import SendIcon from '@mui/icons-material/Send';
import { TemplateJobs } from '../templatejobs';
export const mainListItems =
    [ 

      {
        
        item:(<ListItemButton>
          <ListItemIcon>
            <AdminPanelSettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Administrador" />
        </ListItemButton>),
        content:<AdmPage/>,
        url:`${ROUTES.control}/adm`,
        needPermission:['is_adm_max'],
      },
      {
        
        item:(<ListItemButton>
          <ListItemIcon>
            <AccountBalanceIcon />
          </ListItemIcon>
          <ListItemText primary="Caixa" />
        </ListItemButton>),
        content:<CashBook/>,
        url:`${ROUTES.control}/caixa`,
      },
      {item:(<ListItemButton>
      <ListItemIcon>
        <QueryStatsIcon />
      </ListItemIcon>
      <ListItemText primary="Dashboard" />
    </ListItemButton>),
    url:`${ROUTES.control}/dashboard`,
    needPermission:['can_see_complete_propostal_info','can_see_propostals'],
    content:<DashPage/>
    },
      {item:(<ListItemButton>
      <ListItemIcon>
        <PeopleIcon />
      </ListItemIcon>
      <ListItemText primary="Conversas" />
    </ListItemButton>),
    url:`${ROUTES.control}/conversas`,
    content:<WAConteiner/>,
    needPermission:['can_see_conversation'],
    },
    {item:(<ListItemButton>
      <ListItemIcon>
        <GradingIcon />
      </ListItemIcon>
      <ListItemText primary="FGTS Propostas" />
    </ListItemButton>),
    url:`${ROUTES.control}/fgtspropostas`,
    needPermission:['operate_fgts'],
    content:<Propostals/>
    },
    {item:(<ListItemButton>
      <ListItemIcon>
        <PersonIcon />
      </ListItemIcon>
      <ListItemText primary="Especifico" />
    </ListItemButton>),
    url:`${ROUTES.control}/conversa/especifica`,
    needPermission:['can_see_complete_propostal_info','can_see_conversation','can_see_propostals','operate_fgts'],
    content:<ConversationSearch/>
    },
    {item:(<ListItemButton>
      <ListItemIcon>
        <EngineeringIcon />
      </ListItemIcon>
      <ListItemText primary="Emprestímo CLT" />
    </ListItemButton>),
    url:`${ROUTES.control}/clt`,
    needPermission:['operate_clt'],
    content:<CLT/>
    },
    {item:(<ListItemButton>
      <ListItemIcon>
        <ContactMailIcon />
      </ListItemIcon>
      <ListItemText primary="Leads Usuário" />
    </ListItemButton>),
    url:`${ROUTES.control}/userLeads`,
    needPermission:['can_clear_leads_clt'],
    content:<UserLeads/>
    },
    {item:(<ListItemButton>
      <ListItemIcon>
        <BugReportIcon />
      </ListItemIcon>
      <ListItemText primary="Test Chat" />
    </ListItemButton>),
    url:`${ROUTES.control}/testchat`,
    needPermission:['is_adm_max'],
    content:<TestChat/>
    },
    {item:(<ListItemButton>
      <ListItemIcon>
        <SendIcon />
      </ListItemIcon>
      <ListItemText primary="Disparos Template" />
    </ListItemButton>),
    url:`${ROUTES.control}/disparos`,
    needPermission:['is_adm_max'],
    content:<TemplateJobs/>
    },
  ]

export const secondaryListItems = [

    {item:(<ListItemButton>
      <ListItemIcon>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText primary="Deslogar" />
    </ListItemButton>),
    url:`${ROUTES.control}/sair`,
    content:<Logout/>
   }
]
;